module.exports = __webpack_public_path__ + "img/coka-01.96e93b21.png";